export default __webpack_public_path__ + "static/media/1.7e7d9e2e.jpg";